module.exports = __webpack_public_path__ + "34a28aedd1851ec4ee37a6abd047455d.woff";


//////////////////
// WEBPACK FOOTER
// ./src/uikit/assets/font/noto-sans-kr-v11-korean_latin-900.woff
// module id = 463
// module chunks = 0